import {  SectionOne, SectionTwo } from "../components/feature/services";

export default function Service()
{
    return(
        <section className="">
            <SectionOne/>
            <SectionTwo/>
        </section>
    );
}